// extracted by mini-css-extract-plugin
module.exports = {"chat-btn":"a10a3f92e9--chat-btn--ha45d","closed-state":"a10a3f92e9--closed-state--lfdLV"};